<template>
    <address
        v-if="isInline"
        v-text="inline(address)"
    />

    <address v-else>
        <div v-if="address.street">{{ address.street }}</div>
        <div v-if="address.locality">{{ address.locality }}</div>
        <div v-if="address.village">{{ address.village }}</div>
        <div v-if="address.town">{{ address.town }}</div>
        <div v-if="address.county">{{ address.county }}</div>
        <div v-if="address.postcode">{{ address.postcode }}</div>
    </address>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            address: {
                type: Object,
                required: true
            },
            isInline: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            inline (address) {
                return _.chain([
                    address.street,
                    address.locality,
                    address.village,
                    address.town,
                    address.county,
                    address.postcode
                ])
                    .filter()
                    .join(', ')
            }
        }
    }
</script>
